<template>
  <b-container class="p-3">
    <b-row>
      <b-col>
        <b-form-input
          v-model="form_data.email"
          id="input-email"
          placeholder="Email"
          type="text"
        />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="6">
        <b-button variant="primary" block @click="createAltEmail">
          Add
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component

// api call
import UserAltEmailAPI from '@/api/UserAltEmailAPI'

export default {
  name: 'FormAlternativeEmail',
  props: ['user'],
  components: {
  },
  data () {
    return {
      form_data: {
        sg_user_id: this.user._id,
        email: ''
      },

      errors: []
    }
  },
  methods: {
    // PREREQUISITES
    childData (id, value) {
      // catch value from custom form template
      this.form_data[id] = value
    },
    // END PREREQUISITES

    // HTTP REQUEST
    createAltEmail: async function () {
      await UserAltEmailAPI.createAltEmail(this.form_data)

      swal({
        title: 'Successfully saved!',
        icon: 'success',
        button: {
          text: 'Ok'
        }
      })

      this.form_data.sg_user_id = this.user._id
      this.form_data.email = ''
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/templates/FormAlternativeEmail/FormAlternativeEmail.vue